import { Text } from '@chakra-ui/react';
import Widget from './Widget';
import { useNetworkCharacteristicsKPI } from '../../context/reports-api-hooks';
import { CircleIndicator } from '../indicators';
import { roundKpiValue } from '../../shared/helpers';

export default function NetworkPhysicalCharacteristicsWidget() {
  const { data: networkPhysicalCharacteristicsData, isLoading, isError } = useNetworkCharacteristicsKPI();

  const title = 'Network Physical\nCharacteristics';
  const description = 'Change in road network\nlength over 10 years';

  // If there is an error we want to hide the widget
  if (isError) return null;

  return (
    <Widget
      link="/performance/dashboard/network-physical-characteristics"
      title={title}
      description={description}
      lockYear={networkPhysicalCharacteristicsData?.lockYear}
      quarter={null}
      isLoading={isLoading && !networkPhysicalCharacteristicsData}
      moreInfoContent={
        <Text fontSize="sm">The average change in road network length per year for the last ten years.</Text>
      }
    >
      <CircleIndicator
        size={100}
        colour={networkPhysicalCharacteristicsData?.percentage !== undefined ? 'gray.700' : null}
        value={networkPhysicalCharacteristicsData?.percentage !== undefined ? `${roundKpiValue(networkPhysicalCharacteristicsData?.percentage, 0.1, 2, 'max', 1)}%` : undefined}
        isLoading={isLoading || !networkPhysicalCharacteristicsData}
      />
    </Widget>
  );
}
